import clsx from 'clsx'
import { InputSwitch } from 'primereact/inputswitch'
import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
  REACT_APP_BRANCH_PREFIX,
  REACT_APP_PARENT_APP_DOMAIN,
} from 'utils/constants/environment'

const showDevLangSwitch = REACT_APP_PARENT_APP_DOMAIN?.includes('dev')

export default function VolunteerLeftSideBar({
  collapse,
  onClose,
}: {
  collapse?: boolean
  onClose?: () => void
}) {
  const { i18n } = useTranslation()
  const logoSrc = useMemo(() => {
    if (window.location.origin.includes(REACT_APP_BRANCH_PREFIX)) {
      return '/images/logo-branch.svg'
    }
    return '/images/logo-app.svg'
  }, [])

  useEffect(() => {
    localStorage.setItem('lang', i18n.language)
    document.documentElement.style.setProperty(
      '--font-family',
      i18n.language !== 'jp' ? 'Poppins' : 'Noto Sans'
    )
  }, [i18n.language])

  return (
    <div
      className={clsx(
        'card bg-white flex flex-column h-full transition-duration-300 overflow-hidden flex-nowrap sticky top-0'
      )}
      style={{
        flex: collapse ? '0 0 0' : '0 0 14rem',
        minHeight: '100vh',
      }}
    >
      <div className="flex align-items-center justify-content-between px-3 md:px-4 py-3 md:py-4 gap-2 flex-shrink-0">
        <div className="inline-flex align-items-center w-full">
          <img
            src={logoSrc}
            alt="logo"
            className={clsx('max-w-full', onClose ? 'w-8rem' : 'w-full')}
          />
        </div>
        {onClose ? (
          <button
            type="button"
            className="p-2 border-none bg-transparent cursor-pointer"
            onClick={onClose}
            aria-label="Close"
          >
            <i className="isax isax-close-01 text-xl" />
          </button>
        ) : null}
      </div>
      <div className="flex-1 min-h-0" />
      {showDevLangSwitch ? (
        <div className="px-4 py-3 border-top-1 surface-border flex-shrink-0">
          <div className="flex gap-2 align-items-center">
            English
            <InputSwitch
              checked={i18n.language !== 'jp'}
              onChange={() => {
                const lang = i18n.language !== 'jp' ? 'jp' : 'en'
                i18n.changeLanguage(lang)
                localStorage.setItem('lang', lang)
              }}
            />
          </div>
        </div>
      ) : null}
    </div>
  )
}
